import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Transition } from 'react-transition-group'

interface ProgressBarProps {
  width: number
  percent: number
}

interface StyledProgressBarProps {
  width: number
  barWidth: number
  state: 'entering' | 'entered' | 'exiting' | 'exited' | 'unmounted'
}

const StyledBar = styled.div<StyledProgressBarProps>`
  width: ${(props) => (props.state === 'entered' ? props.width + 10 : props.width + 10)}px;
  margin: 24px auto 0 auto;
  background-color: #71c5e8;
  border: 5px solid #f0f0f0;
  border-radius: 8.5px;
  transform: ${(props) => (props.state === 'entered' ? 'scale(1)' : 'scale(0)')};
  opacity: ${(props) => (props.state === 'entered' ? 1 : 0)};
  transition: 0.1s ease-in-out;
  .progress-bar {
    background-color: #006298;
    width: ${(props) => (props.state === 'entered' ? props.barWidth : 0)}px;
    height: ${(props) => (props.state === 'entered' ? 7 : 0)}px;
    transform: ${(props) => (props.state === 'entered' ? 'scale(1)' : 'scale(0)')};
    opacity: ${(props) => (props.state === 'entered' ? 1 : 0)};
    border-radius: 3.5px;
    transition: all ease 0.15s;
  }
`

export const ProgressBar: React.FC<ProgressBarProps> = ({ width, percent }) => {
  const barWidth = (width * percent) / 100

  return (
    <Transition in={percent > 0} timeout={400}>
      {(state) => (
        <StyledBar width={width} barWidth={barWidth} state={state}>
          <div className="progress-bar"></div>
        </StyledBar>
      )}
    </Transition>
  )
}
